import React from 'react'

const Intro = () => {
  const businessImg = "/images/concept-partner-discussion-business-projects.png";

  return (
    <section className='relative min-h-screen flex items-center justify-center overflow-hidden py-24 z-0'>
      
      {/* 1. Background dynamique hérité de votre structure globale */}
      <div className='ueber_uns-Intro'></div>

      {/* 2. Conteneur de contenu avec effet de superposition */}
      <div className='relative z-10 w-full max-w-6xl mx-auto px-6 flex flex-col items-center text-center'>
        
        {/* Badge de catégorie */}
        <div className='mb-6 px-6 py-2 bg-white/10 backdrop-blur-md border border-white/20 rounded-full shadow-xl animate-bounce-slow'>
          <span className='text-primary font-extrabold tracking-widest text-xs md:text-sm uppercase'>
            projekte & showcase
          </span>
        </div>

        {/* Titre avec lettrage massif et dégradé */}
        <div className='relative mb-10'>
          <h1 className="text-4xl md:text-6xl font-black text-secondary uppercase tracking-tighter leading-none">
            PRO<span className="text-primary">JEKTE</span>
          </h1>
          {/* Ligne de séparation stylisée centrée */}
          <div className='w-32 h-2 bg-gradient-to-r from-primary to-secondary mx-auto mt-4 rounded-full'></div>
        </div>

        {/* Description optimisée SEO et typographie aérée */}
        <p className="text-slate-700 text-lg md:text-1xl font-semibold leading-relaxed max-w-2xl mb-12 opacity-90">
          Wir verwandeln komplexe Anforderungen in <span className='text-primary'>ergebnisorientiertes Webdesign</span>. 
          Unsere Referenzen spiegeln höchste Standards in der <span className='text-primary'>nutzerzentrierten Entwicklung</span> 
          und nachhaltige Erfolge durch <span className='text-primary'>Konversionsoptimierung</span> wider.
        </p>

        {/* Bloc Image central avec effet de lévitation et reflet */}
        <div className='relative w-full max-w-2xl group'>
          <div className='absolute -inset-4 bg-gradient-to-r from-primary/30 to-secondary/30 blur-3xl rounded-full opacity-50 group-hover:opacity-80 transition-opacity duration-1000'></div>
          <img 
            src={businessImg} 
            alt="Unsere Projekte Showcase" 
            className="relative z-10 w-full h-auto object-contain drop-shadow-[0_35px_35px_rgba(0,0,0,0.25)] animate-float"
          />
          
          {/* Slogan discret sous l'image */}
          <div className="absolute -bottom-10 left-1/2 -translate-x-1/2 w-full">
            <p className="text-secondary/60 font-bold tracking-[0.5em] text-xs md:text-sm uppercase">
              Innovation • Qualität • Performance
            </p>
          </div>
        </div>

      </div>
    </section>
  );
};

export default Intro